/**
 *  Rat seeks to find a hole
 *  Moves left and right
 * 
 */

import { gSettings } from "../settings/gamesettings";
import * as mJS from  '../common/mvUtils.js'

export default class Rat {

hasSprite = false;
id = 0;
posX = 0;
posY = 0;
direction = 0; 
animationFrame = 0;
animationState = 0; // 0 = run, 1 = fall, 2 = climb, 3 = nest, 4 = die 
ratLastMove = 0;
isFalling = false;
killRat = false;
killSprite = false;
nestedRat = false;
isHomed = false;
currentlyNested = false;
ratType = 8;

    constructor(posX, posY, id ) {
        this.id = id;
        this.posX = posX;
        this.posY = posY;
        if (mJS.getRandomInt(0,1) == 0) {
            this.direction = -1;
        } else {
            this.direction = 1;
        }

        let spawnID = mJS.getRandomInt(1,10);
        switch(spawnID) {
            default:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                this.ratType = 8;
            break;
            case 7:
            case 8:
            case 9:
                this.ratType = 9;
            break;
            case 10:                
                this.ratType = 10;
            break;

        }


    }
    update(grid, delta, time) {

        // TODO move rat logic to here check if no lines

    

   
    }

    

    setPos(valueX, valueY) {

        this.posX = valueX;
        this.posY = valueY;

    }

    getPosY() {
        return this.posY;
    } 
   
    getPosX() {
        return this.posX;
    } 

    draw() {

    }




}
